export default {
      id: "danger-usage",
      viewBox: "0 0 29 26",
      url: __webpack_public_path__ + "img/icons.svg#danger",
      toString: function () {
        return this.url;
      }
    }